import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SERVICE_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemServiceFeeMaybe = props => {
  const { lineItems, isCustomer, intl } = props;

  const serviceFeeLineItem = lineItems.find(
    item =>
      item.code === LINE_ITEM_SERVICE_FEE &&
      !item.reversal &&
      item.includeFor.includes('customer') &&
      !item.includeFor.includes('provider')
  );

  return isCustomer && serviceFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.serviceFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, serviceFeeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemServiceFeeMaybe.propTypes = {
  isCustomer: bool.isRequired,
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemServiceFeeMaybe;
